// Get Google Analytics ID from environment variable or fallback to hardcoded value
// This allows for different IDs in development vs production
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-FLBKLXFZ4M';

// Initialize Google Analytics
export const initGA = () => {
  console.log('Attempting to initialize Google Analytics...');
  console.log('GA_MEASUREMENT_ID:', GA_MEASUREMENT_ID);
  console.log('Environment:', process.env.NODE_ENV);
  
  // Only initialize if we have a valid measurement ID
  if (GA_MEASUREMENT_ID === 'GA_MEASUREMENT_ID' || !GA_MEASUREMENT_ID) {
    console.log('Google Analytics not initialized - missing measurement ID');
    return;
  }

  // Load the Google Analytics script
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_title: document.title,
    page_location: window.location.href,
  });
  
  console.log('Google Analytics initialized with ID:', GA_MEASUREMENT_ID);
};

// Track page views
export const trackPageView = (path, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track specific user interactions
export const trackButtonClick = (buttonName, location) => {
  trackEvent('click', 'button', `${buttonName} - ${location}`);
};

export const trackLinkClick = (linkName, destination) => {
  trackEvent('click', 'link', `${linkName} - ${destination}`);
};

export const trackModalOpen = (modalName) => {
  trackEvent('open', 'modal', modalName);
};

export const trackPageSection = (sectionName) => {
  trackEvent('view', 'section', sectionName);
};
